import React from "react";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
import { Table, Typography, Tag } from "antd";
import ContractDayType from "../../../components/tables/ContractDayType";
import moment from "moment";
const { Text } = Typography;

const OverlappingShifts = (props) => {
  const { overlappingShifts } = props;

  const intl = useIntl();
  const columns = [
    {
      title: <FormattedMessage id={"app.forms.contract.shifts.day_type"} />,
      dataIndex: "day_type",
      render: (text, record, index) => <ContractDayType text={text} />,
    },
    {
      title: <FormattedMessage id={"app.forms.contract.shifts.day_of_week"} />,
      dataIndex: "day",
      render: (text, record, index) => (
        <Tag style={{ margin: "2px" }}>{moment.weekdays(true)[text]}</Tag>
      ),
    },
    {
      title: (
        <FormattedMessage id={"app.forms.contract.shifts.start_time_minutes"} />
      ),
      dataIndex: "start",
      render: (text, record, index) => {
        return <Text>{text && moment(text).format("HH:mm")}</Text>;
      },
    },
    {
      title: <FormattedMessage id={"app.forms.contract.shifts.end_time"} />,
      dataIndex: "start",
      render: (text, record, index) => {
        return (
          <Text>
            {text && moment(text).add(record.duration, "hour").format("HH:mm")}
          </Text>
        );
      },
    },
    {
      title: (
        <FormattedMessage id={"app.forms.contract.shifts.end_time_minutes"} />
      ),
      dataIndex: "duration",
      render: (text, record, index) => {
        return (
          <Text>
            {text &&
              `${text} ${intl.formatMessage({
                id: "app.contracts.hours",
              })}`}
          </Text>
        );
      },
    },
  ];

  return (
    <Table
      bordered
      columns={columns}
      dataSource={overlappingShifts}
      size="small"
      rowKey={(record) => record.id}
    />
  );
};

export default OverlappingShifts;
